import Box from "@mui/material/Box";
import { ReactNode } from "react";
import "./layout.css";
import Header from "@/components/header";
const LandingLayout = ({ children, gotoHome }: { children: ReactNode, gotoHome :VoidFunction }) => {
  return (
    <Box sx={{
          height: "100vh",
          width: "100%",display:"flex", flexDirection:"column",
          overflow:"hidden"
        }}>
    <Header sx={{ p:2}} gotoHome={gotoHome}/>
      <Box
        sx={{
            flex:1,
            zIndex:-1,
        }}
      >
        {/* <img src={"https://sr-cdn-1.shiprocket.in/sr-promise/images/particles.gif"} style={{
          opacity:0.3,
          animationDuration : "400ms"
        }} className="animate__animated animate__fadeOut z-[0]" /> */}
        <div className="bg_blur animate__animated animate__zoomIn" style={{
          animationDuration : "300ms"
        }}>
          <div className="layout_landing "></div>
          <div
            className="layout_landing rotate_90"
            style={{ height: "80vh", width: "80vh" }}
          ></div>
        </div>

        
      </Box><Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex:3
          }}
        >
          {children}
        </Box>
    </Box>
  );
};

export default LandingLayout;
